import { CheckCircle2, Clock, AlertTriangle, Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useMeetings } from "@/providers/MeetingsProvider";

export function MeetingStatsHeader() {
  const { stats, isStatsLoading, setDashboardState } = useMeetings();

  if (isStatsLoading) {
    return (
      <div className="flex items-center gap-2 text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span className="text-sm">Loading stats...</span>
      </div>
    );
  }

  if (!stats) return null;

  const items = [
    {
      label: "Confirmed",
      value: stats.confirmed,
      icon: CheckCircle2,
      color: "text-emerald-400",
      bg: "bg-emerald-500/10",
      tab: "UPCOMING" as const,
    },
    {
      label: "Pending",
      value: stats.pending,
      icon: Clock,
      color: "text-amber-400",
      bg: "bg-amber-500/10",
      tab: "PENDING" as const,
    },
    {
      label: "No-shows",
      value: stats.noShow,
      icon: AlertTriangle,
      color: "text-red-400",
      bg: "bg-red-500/10",
      tab: "NO_SHOW" as const,
    },
  ];

  return (
    <div className="flex items-center gap-3">
      {items.map((item) => (
        <button
          key={item.label}
          onClick={() => setDashboardState({ activeTab: item.tab })}
          className="flex items-center gap-2 group"
        >
          <Badge
            variant="outline"
            className={`${item.bg} ${item.color} border-transparent gap-1.5 px-2.5 py-1 group-hover:opacity-80 transition-opacity`}
          >
            <item.icon className="h-3 w-3" />
            {item.value} {item.label}
          </Badge>
        </button>
      ))}
    </div>
  );
}
